module.exports = __webpack_public_path__ + "static/img/lh-bg.e121b816.jpg";